import { render, staticRenderFns } from "./integrations.vue?vue&type=template&id=78e6bbdd&scoped=true&"
import script from "./integrations.vue?vue&type=script&lang=js&"
export * from "./integrations.vue?vue&type=script&lang=js&"
import style0 from "./integrations.vue?vue&type=style&index=0&id=78e6bbdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e6bbdd",
  null
  
)

export default component.exports